import ReportsDetailsPanel from './ReportsDetailsPanel';

export default ReportsDetailsPanel;
